export default "__VITE_ASSET__BJVx$C5K__"